<template>
  <div class="staff-list-block">
    <div
      v-if="showThankYou && (data.heading || data.subheading)"
      class="general-info-department"
    >
      <div class="general-info-department__info-block">
        <div v-if="data.heading" class="general-info-department__title-left">
          <p class="text-TTDrugs-Bold-40 color-green center text-uppercase">{{ data.heading }}</p>
        </div>
        <div v-if="data.subheading" class="general-info-department__description">
          <p class="text-circe-20 color-gray">{{ data.subheading }}</p>
        </div>
      </div>
      <div class="general-info-department__thank">
        <BlockThankYou />
      </div>
    </div>
    <div v-else-if="data.heading" class="staff-list-block__header">
      <p class="text-TTDrugs-Bold-40 color-green center text-uppercase">{{ data.heading }}</p>
      <p v-if="data.subheading" class="text-circe-20 color-gray center">{{ data.subheading }}</p>
    </div>
    <div v-else-if="showThankYou" class="general-info-department">
      <div class="general-info-department__info-block" />
      <div class="general-info-department__thank">
        <BlockThankYou />
      </div>
    </div>
    <div v-if="loadError" class="staff-list-block__error text-circe-18 color-gray">
      Не удалось загрузить список специалистов
    </div>
    <AppLoader v-else-if="loading" />
    <AppDoctorsPeopleList v-else-if="peopleList.length" :people_list="peopleList" />
  </div>
</template>

<script>
import DepartmentAPi from "@/api/department";
import AppDoctorsPeopleList from "@/components/People/DoctorsPeopleList.vue";
import AppLoader from "@/components/Loader.vue";
import BlockThankYou from "@/components/BlockThankYou.vue";

function extractEmployeeList(res) {
  const body = res && res.data !== undefined ? res.data : res;
  if (Array.isArray(body)) {
    return body;
  }
  if (body && body.status === "SUCCESS" && Array.isArray(body.result)) {
    return body.result;
  }
  return [];
}

export default {
  name: "AppStaffListBlock",
  components: { AppDoctorsPeopleList, AppLoader, BlockThankYou },
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      loading: true,
      loadError: false,
      peopleList: [],
    };
  },
  computed: {
    showThankYou() {
      return !!(this.data && this.data.showThankYou);
    },
  },
  watch: {
    data: {
      deep: true,
      handler() {
        this.loadPeople();
      },
    },
  },
  mounted() {
    this.loadPeople();
  },
  methods: {
    normalizePerson(emp) {
      if (!emp) {
        return null;
      }
      const rawId = emp.id != null ? emp.id : emp._id;
      if (rawId === undefined || rawId === null || String(rawId).trim() === "") {
        return null;
      }
      return {
        ...emp,
        id: String(rawId).trim(),
        opening: emp.openingHours || emp.opening || "",
      };
    },

    mergeOrderedManualThenSubDept(manualList, subDeptList) {
      const seen = new Set();
      const out = [];
      for (const raw of manualList || []) {
        const p = this.normalizePerson(raw);
        if (p && !seen.has(p.id)) {
          seen.add(p.id);
          out.push(p);
        }
      }
      for (const raw of subDeptList || []) {
        const p = this.normalizePerson(raw);
        if (p && !seen.has(p.id)) {
          seen.add(p.id);
          out.push(p);
        }
      }
      return out;
    },

    async loadPeople() {
      const useManual = !!this.data.useManualList && Array.isArray(this.data.employeeIds) && this.data.employeeIds.length > 0;
      const useSub = !!this.data.useSubDepartment && !!String(this.data.subDepartmentName || "").trim();

      if (!useManual && !useSub) {
        this.loading = false;
        this.loadError = false;
        this.peopleList = [];
        return;
      }

      this.loading = true;
      this.loadError = false;
      try {
        const ids = (this.data.employeeIds || [])
          .map((id) => String(id).trim())
          .filter(Boolean);
        const manualPromise = useManual
          ? DepartmentAPi.postEmployeesByIds(ids)
          : Promise.resolve({ data: [] });
        const subPromise = useSub
          ? DepartmentAPi.getDoctorsUnderDepartment(String(this.data.subDepartmentName).trim())
          : Promise.resolve({ data: [] });

        const [manualRes, subRes] = await Promise.all([manualPromise, subPromise]);
        const manual = extractEmployeeList(manualRes);
        const sub = extractEmployeeList(subRes);
        this.peopleList = this.mergeOrderedManualThenSubDept(manual, sub);
      } catch (e) {
        this.loadError = true;
        this.peopleList = [];
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.staff-list-block {
  width: 100%;
}

.staff-list-block__header {
  margin-bottom: 20px;
}

.staff-list-block__error {
  padding: 16px 0;
}
</style>
